var exports = {
  "wQ": "SudoVerificationModal.module__passkeyVerifying___TjFYWT",
  "hU": "SudoVerificationModal.module__unavailable___TjFYWT",
  "TJ": "SudoVerificationModal.module__unavailableTitle___TjFYWT",
  "$r": "SudoVerificationModal.module__unavailableBody___TjFYWT",
  "zc": "SudoVerificationModal.module__formError___TjFYWT",
  "kK": "SudoVerificationModal.module__passkeyHint___TjFYWT",
};

module.exports = exports;
